import { createRoot } from "react-dom/client";
import App from "./components/App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import {
  FluentProvider,
  createLightTheme,
  BrandVariants,
} from "@fluentui/react-components";
import { I18nProvider } from "../i18n/I18nProvider";

// Deskare brand color palette based on #005BFF
const deskareBrand: BrandVariants = {
  10: "#001433",
  20: "#002266",
  30: "#003099",
  40: "#003ECC",
  50: "#004CFF",
  60: "#005BFF", // Primary Deskare blue
  70: "#3379FF",
  80: "#5C94FF",
  90: "#85AFFF",
  100: "#ADCAFF",
  110: "#C7DAFF",
  120: "#D6E5FF",
  130: "#E5EEFF",
  140: "#F0F5FF",
  150: "#F7FAFF",
  160: "#FCFDFF",
};

const deskareTheme = createLightTheme(deskareBrand);

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
  root?.render(
    <I18nProvider>
      <FluentProvider theme={deskareTheme}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </FluentProvider>
    </I18nProvider>
  );
});
